<div class="feedback" *ngIf="feedback">
  <div *ngIf="!isFeebackStarted && !isFeebackFinihsed" class="feedback-intro">
    <div class="feedback-intro-wrapper">
      <img class="feedback-logo" [src]="feedback.logoUrl" />
      <div class="feedback-description">
        {{ "FEEDBACK.INTRO" | translate }}
      </div>
      <div class="feedback-stats">
        <div class="feedback-stat">
          <div class="feedback-stat-name">
            {{ ("COMMON.FIELDS.DATE" | translate) + ":" }}
          </div>
          <div class="feedback-stat-value">{{ feedback.eventDate }}</div>
        </div>
        <div class="feedback-stat">
          <div class="feedback-stat-name">
            {{ ("COMMON.FIELDS.EVENT" | translate) + ":" }}
          </div>
          <div class="feedback-stat-value">{{ feedback.eventTitle }}</div>
        </div>
        <div *ngIf="feedback.eventTrainer" class="feedback-stat">
          <div class="feedback-stat-name">
            {{ ("COMMON.FIELDS.TRAINER" | translate) + ":" }}
          </div>
          <div class="feedback-stat-value">{{ feedback.eventTrainer }}</div>
        </div>
      </div>
      <dx-button
        [text]="'FEEDBACK.GIVE-FEEDBACK' | translate"
        type="normal"
        (click)="onStartFeedback()"
      ></dx-button>
    </div>
  </div>
  <div *ngIf="isFeebackStarted && !isFeebackFinihsed">
    <div class="feedback-questions">
      <div
        [hidden]="idx !== currentPage"
        *ngFor="let page of feedback.survey.pages; let idx = index"
      >
        <div class="feedback-questions-wrapper">
          <dx-progress-bar
            [min]="0"
            [max]="100"
            [value]="progressPersentage"
            [showStatus]="false"
          ></dx-progress-bar>
          <div class="feedback-questions-meta">
             <span class="feedback-questions-meta-section">
              {{ "FEEDBACK.SECTION-OF" | translate: { current: idx + 1, total: feedback.survey.pages.length } }} · {{ page.title }}
            </span>
            <span 
              class="feedback-questions-meta-time"
              *ngIf="feedback.survey.estimatedCompletionTimeMinutes"
            >
              {{ "COMMON.APPROX" | translate }} {{ feedback.survey.estimatedCompletionTimeMinutes }} {{ "COMMON.MIN" | translate }}
            </span>
          </div>
          <div class="feedback-questions-page">
            {{ feedback.survey.pages[currentPage].title }}
          </div>
          <div 
            class="feedback-rating-legend" 
            *ngIf="currentPage !== feedback.survey.pages.length - 1"
          >
            <div class="feedback-rating-legend-label">
              {{ "FEEDBACK.RATE-USING-STARS" | translate }}
            </div>
            <div class="feedback-rating-legend-chip-container">
              <span class="feedback-rating-legend-chip">
                <span class="feedback-rating-legend-star">★</span>
                {{ "FEEDBACK.STRONGLY-DISAGREE" | translate }}
              </span>
              <span class="feedback-rating-legend-chip">
                <span class="feedback-rating-legend-star" *ngFor="let s of ratings">★</span>
                {{ "FEEDBACK.STRONGLY-AGREE" | translate }}
              </span>
            </div>
          </div>
          <div *ngFor="let question of page.questions">
            <div
              [hidden]="question.type === SurveyQuestionType.GroupLabel"
              class="feedback-questions-question"
            >
              <div class="feedback-questions-question-text">
                {{ question.text }}
              </div>
              <div
                *ngIf="question.type == SurveyQuestionType.RadioSelectNumeric"
              >
                <div class="feedback-rating">
                  <div class="feedback-rating-star-container">
                    <span
                      *ngFor="let rating of ratings"
                      class="feedback-rating-star"
                      [class.active]="
                        rating <= (hoveredRatings[question.id] || selectedRatings[question.id] || 0)
                      "
                      (mouseenter)="hoveredRatings[question.id] = rating"
                      (mouseleave)="hoveredRatings[question.id] = 0"
                      (click)="onRatingSelected(rating, question.id)"
                    >
                      ★
                    </span>
                  </div>
                  <div class="feedback-rating-result" *ngIf="selectedRatings[question.id]">
                    <b>{{ selectedRatings[question.id] }} {{ "COMMON.OF" | translate }} {{ ratings.length }}</b>
                    — {{ ratingLabels[selectedRatings[question.id]] | translate }}
                  </div>
                </div>
                <div class="feedback-rating-endpoints">
                  <span>{{ "FEEDBACK.DISAGREE" | translate }}</span>
                  <span>{{ "FEEDBACK.STRONGLY-AGREE" | translate }}</span>
                </div>
              </div>
              <div *ngIf="question.type == SurveyQuestionType.FreeTextInput">
                <dx-text-area
                  class="feedback-questions-question-answer"
                  valueChangeEvent="input"
                  (onValueChanged)="onTextQuestionAnswered($event, question.id)"
                ></dx-text-area>
              </div>
            </div>
            <div
              [hidden]="question.type !== SurveyQuestionType.GroupLabel"
              class="feedback-questions-question-separator"
            >
              {{ question.text }}
            </div>
          </div>

          <div class="feedback-questions-cta">
            <dx-button
              *ngIf="currentPage !== 0"
              class="feedback-questions-back"
              [text]="'COMMON.BACK' | translate"
              type="default"
              (click)="previousPage()"
            ></dx-button>
            <dx-button
              *ngIf="currentPage !== feedback.survey.pages.length - 1"
              [text]="'COMMON.NEXT' | translate"
              type="normal"
              (click)="nextPage()"
            ></dx-button>
            <dx-button
              *ngIf="currentPage === feedback.survey.pages.length - 1"
              [text]="'COMMON.SUBMIT' | translate"
              type="normal"
              (click)="submitFeedback()"
            ></dx-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isFeebackStarted && isFeebackFinihsed" class="feedback-finish">
    <div class="feedback-finish-wrapper">
      <div class="feedback-finish-title">
        {{ "FEEDBACK.SURVEY-COMPLETED" | translate }}
      </div>
      <div class="feedback-finish-description">
        {{ "FEEDBACK.THANK-YOU" | translate }}
      </div>
    </div>
  </div>
</div>
